import React, { useState, useEffect } from 'react';
import './sidebar.scss';
import thankyou from '../thankyou.png';

const SideForm = ({ title, isOpen, toggleDrawer, selectedData, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    city: '',
    state: '',
    zipcode: '',
    facebook: '',
    instagram: '',
    twitter: '',
    google: '',
    website: '',
  });
  const [initialData, setInitialData] = useState({});
  const [showThankYou, setShowThankYou] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    if (selectedData) {
      const newFormData = {
        name: selectedData.name || '',
        address: selectedData.info?.address?.street || '',
        city: selectedData.info?.address?.city || '',
        state: selectedData.info?.address?.state || '',
        zipcode: selectedData.info?.address?.zipcode || '',
        facebook: selectedData.info?.social?.facebook || '',
        instagram: selectedData.info?.social?.instagram || '',
        twitter: selectedData.info?.social?.twitter || '',
        google: selectedData.info?.social?.google || '',
        website: selectedData.info?.website || '',
      };
      setFormData(newFormData);
      setInitialData(newFormData);
    }
  }, [selectedData]);

  const handleChange = (e) => {
    const updatedFormData = { ...formData, [e.target.name]: e.target.value };
    setFormData(updatedFormData);
    setIsChanged(JSON.stringify(updatedFormData) !== JSON.stringify(initialData));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFadeOut(true);
    
    try {
      const response = await fetch('submit.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        setTimeout(() => {
          setShowThankYou(true);
          setFadeOut(false);
          setTimeout(() => {
            setShowThankYou(false);
            toggleDrawer();
          }, 5000);
        }, 300);
        onSave(formData);
        setIsChanged(false);
      } else {
        console.error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <>
      <div className={`overlay ${isOpen ? 'show' : ''}`} onClick={toggleDrawer}></div>
      <div className={`side-drawer ${isOpen ? 'open' : ''} ${fadeOut ? 'fade-out' : ''}`}>
        {!showThankYou ? (
          <>
            <button className="close-btn" onClick={toggleDrawer}>&#10005;</button>
            <h3>{title}</h3>
            <form onSubmit={handleSubmit}>
              <label>Name<sup>*</sup></label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />
              <label>Address<sup>*</sup></label>
              <input type="text" name="address" value={formData.address} onChange={handleChange} required />
              <label>City<sup>*</sup></label>
              <input type="text" name="city" value={formData.city} onChange={handleChange} required />
              <label>State<sup>*</sup></label>
              <input type="text" name="state" value={formData.state} onChange={handleChange} required />
              <label>Zipcode</label>
              <input type="text" name="zipcode" value={formData.zipcode} onChange={handleChange} />
              <label>Socials</label>
              <input type="text" name="facebook" placeholder="Facebook" value={formData.facebook} onChange={handleChange} />
              <input type="text" name="instagram" placeholder="Instagram" value={formData.instagram} onChange={handleChange} />
              <input type="text" name="twitter" placeholder="Twitter" value={formData.twitter} onChange={handleChange} />
              <input type="text" name="google" placeholder="Google" value={formData.google} onChange={handleChange} />
              <label>Website</label>
              <input type="text" name="website" placeholder="Website" value={formData.website} onChange={handleChange} />
              <button type="submit" disabled={!isChanged}>Save</button>
            </form>
          </>
        ) : (
          <div className="fade-in">
            <img src={thankyou} alt="Thank You"  style={{'width':'150px'}}/>
            <div><h2>Thank you!</h2> <br/>Your submission has been received.</div>
          </div>
        )}
      </div>
    </>
  );
};

export default SideForm;
